import {useTranslation} from 'react-i18next';
import {KeyPairType, SSHKeyPairType} from 'types/diplomat/enums/KeyPairType';
import React from 'react';
import {bitStrengths} from 'common/constants';
import FormikDropdown from 'components/inputs/FormikDropdown';
import {useFieldValueGetter} from 'components/hook-form/useFieldValueGetter';
import {useSetFieldValueCb} from 'components/hook-form/useSetFieldValueCb';

const BitStrengthField = ({name = 'keyType'}: {name?: string}) => {
   const {t} = useTranslation();
   const getValue = useFieldValueGetter<any>();
   const setValue = useSetFieldValueCb<any>();

   const keyType = getValue(name);
   const isSingleOption = keyType === KeyPairType.enum.DSA || keyType === SSHKeyPairType.enum.DSS;

   const options = React.useMemo(() => {
      if (isSingleOption) {
         return [bitStrengths[0]];
      }
      return bitStrengths;
   }, [isSingleOption]);
   React.useEffect(() => {
      if (isSingleOption) {
         setValue('bitStrength', 1024);
      }
   }, [isSingleOption, setValue]);
   return <FormikDropdown name="bitStrength" label={t('Bit Strength')} options={options} />;
};

export default BitStrengthField;
